import React, {
    Component,
} from 'react'
import {
    loginCognitoFacebookUser,
    loginUserViaFacebookWithApi,
} from '../../admin/actions/facebook-auth'
import Loader from '../../front/components/shared/loader'
import { getUrlParameter } from '../../admin/actions'
import withAppleSignIn from '../apple-signin/with-apple-sign-in'
import PropTypes from 'prop-types'
import { getItemFromLocalStorage } from '../../admin/store'
import { redirectToRemoteLoginBacklink } from './remote-login-redirect'

class CognitoCallback extends Component {
    /**
     * Triggers facebook authentication
     * @description On component mount, the cognito tokens were aleardy saved so just fetch the API fb access token from
     * the sessionStorage and call the API login logic. After it remove FB access token from session storage
     * and if was setted redirect url, then go to them, else go to /
     */
    triggerFacebookAuth = () => {
        const token = sessionStorage.getItem('facebookAccessToken')
        const redirectCount = sessionStorage.getItem('facebookRedirectCount')
        const error = getUrlParameter('error')

        if (error === 'invalid_request' && redirectCount === '1') {
            return loginCognitoFacebookUser()
        }

        loginUserViaFacebookWithApi(token)
            .then(() => {
                sessionStorage.removeItem('facebookAccessToken')
                sessionStorage.removeItem('facebookRedirectCount')
            })
            .then(() => {
                redirectToRemoteLoginBacklink(getItemFromLocalStorage('sportnect.tokens'))
                    .catch(() => {
                        const redirectPath = sessionStorage.getItem('facebookLogin.redirectPath')

                        if (redirectPath) {
                            sessionStorage.removeItem('facebookLogin.redirectPath')
                            window.location.href = redirectPath
                        } else {
                            window.location.href = '/'
                        }
                    })
            })
    }

    /**
     * On component mounting, look into the state parameter to find federation type and trigger a reaction
     */
    componentDidMount() {
        const state = getUrlParameter('state')

        if (state === 'provider=Facebook') {
            this.triggerFacebookAuth()
        }

        if (state === 'provider=SignInWithApple') {
            this.props.appleAuthCallback()
        }

        if (!state) {
            window.location.href = '/'
        }
    }

    /**
     * Renders loader while the callback executes
     * @return {*}
     */
    render() {
        return (
            <div className="d-flex justify-content-center">
                <Loader />
            </div>
        )
    }
}

CognitoCallback.propTypes = {
    appleAuthCallback: PropTypes.func.isRequired,
}

export default withAppleSignIn(CognitoCallback)
